import AlsoDevice from 'Components/Also/Device/Device'
import AluxoDevice from 'Components/Aluxo/Device/Device'
import config from 'Lib/config'

const Device = config.reseller.also ? AlsoDevice : AluxoDevice

export default Device
